var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SimplifiedOnboardingModal',{on:{"close":_vm.close},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}})}
var staticRenderFns = []

export { render, staticRenderFns }